module.exports = __webpack_public_path__ + "static/img/logo-light-text.7810e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-light-text.png
// module id = fXYR
// module chunks = 17